import {Email} from "./email"
import {Phone} from "./phone"
import {Switcher} from "./switcher"

const {runComponentAction} = BX.ajax

export const Form = {
    components: {Switcher, Email, Phone},
    methods: {
        setLoading(value) {
            this.$store.commit('setLoading', value)
        },
        togglePhone() {
            if (this.$store.state.loading === true) return
            //this.$store.commit('setMode', 'phone')
        },
        toggleEmail() {
            if (this.$store.state.loading === true) return
            this.$store.commit('setMode', 'email')
        },
        setInitialStep() {
            this.$store.commit('setStep', 'initial')
        },
        sendCode() {
            if (this.$store.state.loading === true) return
            this.setLoading(true)

            let formData = new FormData(), context = this
            formData.set('sessid', BX.bitrix_sessid())
            formData.set('mode', this.$store.state.mode)
            formData.set('email', this.$store.state.email)
            formData.set('phone', this.$store.state.phone)

            runComponentAction('palm:auth', 'checkUser', {
                data: formData,
                mode: 'class'
            }).then(() => {
                context.$store.commit('setStep', 'code')
                context.setLoading(false)
            }, response => {
                let responseErrors = {}
                response.errors.map(error => {
                    responseErrors[error.code] = error.message
                })

                context.setLoading(false)
                context.$store.commit('setErrors', responseErrors)
            })
        },
        applyCode() {
            if (this.$store.state.loading === true) return
            this.setLoading(true)

            let formData = new FormData(), context = this

            formData.set('sessid', BX.bitrix_sessid())
            formData.set('mode', this.$store.state.mode)
            formData.set('email', this.$store.state.email)
            formData.set('phone', this.$store.state.phone)
            formData.set('code', this.$store.state.code)

            runComponentAction('palm:auth', 'applyUser', {
                data: formData,
                mode: 'class'
            }).then(response => {
                const redirect = response.data && response.data.redirect
                if (redirect) {
                    window.location.href = redirect
                } else {
                    window.location.reload()
                }
                context.setLoading(false)
            }, response => {
                let responseErrors = {}
                response.errors.map(error => {
                    responseErrors[error.code] = error.message
                })

                context.setLoading(false)
                context.$store.commit('setCode', '')
                context.$store.commit('setErrors', responseErrors)
            })
        }
    },
    template: `
        <Switcher @togglePhone="togglePhone" @toggleEmail="toggleEmail"  @setInitialStep="setInitialStep"/>
        <Email v-if="this.$store.state.mode === 'email'" @sendCode="sendCode" @applyCode="applyCode" />
        <Phone v-if="this.$store.state.mode === 'phone'" @sendCode="sendCode" />
    `
}
